module.exports = __webpack_public_path__ + "static/media/marketing_use_case_3.a6d508b3.svg";